export const performanceId = {
    performanceNew: {	
        to: "ke",
        AttendanceStatus: 	'Status kehadiran',
        AttendanceTime: "	Waktu kehadiran",
        Last7days:	'1 Minggu terakhir',
        quicklink: "Link",
        OPlog:	"Operasikan Log ",
        precomplete:	" Belum Selesai",
        inbound	:" Telepon Masuk",
        bound:	"Telepon Keluar ",
        APIcall	:" Telepon via API",
        softphonecall:	" Ekstensi Telepon",
        stopCollection: "Berhenti tagih",
        cancelStopCollection: "Batal berhenti tagih",
        selectDate: "Pilih tanggal",
        isSureCancel: "Apakah anda yakin untuk membatalkan berhenti tagih?"
    },
    warningLetter: {
        warningletters: 'Daftar surat peringatan  ',
        Download: 'Download',
        notDownloaded: 'Tidak diunduh',
        alreadyDownloaded: 'Telah didownload',
        alreadySended: 'Telah mengirim',
        sendSuccessfully: 'Kirim sukses',
        pleaseDownloadFirstly: 'Silahkan download dulu',
    },
    urgeLetter: {
        urgeletter: 'Surat Penagihan',
        Download: 'Unduh',
        selectUrgeLetter: 'Silahkan memilih template',
    },
    relation: {
        companyPhone: 	'Nomor telepon kantor',
        person2: 	'Kontak 2',
        person3: 	'Kontak 3',
        self: 	'Pribadi',
        role: 	'Peran',
        person1: 	'Kontak 1',
        DispalyNum: 	'Nomor panggilan',
        DestNum: 	'Nomor tujuan',
        BillID: 	'ID pinjaman',
        Direction: 	'Arah panggilan',
        IsnotConnect: 	'Apakah terhubung',
        OnboardTime: 	'Waktu masuk',
        WaitingDuration: 	'Waktu tunggu',
    },
    CallRecordQuery: {
        RecordingMethod: 	'Metode rekaman',
        RecordingFile: '	File rekaman',
        Supplier: '	Pihak ketiga',
    },
    RiskReport: {
        RiskReport:	'Pelaporan resiko',
        Risk: 	'Resiko',
    },
    CommonParam: {
        ParameterName: '	Nama parameter',
        ParameterDescription:	'Deskripsi parameter',
        OperatingTime: 	'Waktu pengoperasian',
        Operator: 	'Operator',
        ParameterValue: 	'Nilai parameter',
    },
    salaryReport: {
        timelimit:	'Batas waktu',
        whetherthenewstaffofthemonth: 	'Apakah karyawan baru',
        basesalary: 	'Gaji pokok',
        isthefirstofthestaffIDnumber5: 	'Apakah ID karyawan dimulai dengan angka 5',
        basicdailywage: 	'Gaji harian',
        actualbasicsalary: 	'Gaji yang didapat',
        staffcreatetime: 	'Kapan karyawan dibuat',
        CurrentCycle: 	'Minggu ini',
        LastCycle: 	'Minggu lalu',
        CurrentMonth: 	'Bulan ini',
        Wagetimerange: 	'Waktu dapat gaji',
    },
    applicationReview: {
        ApplyReason: "Alasan Pengajuan",
        ApproveOpinion: "Alasan Disetujui",
        Approve: "Menunggu Pengecekan",
        Passed: "Pengajuan Diterima",
        Refused: "Pengajuan Ditolak",
        Failed: "Pemotongan Gagal",
        Successful: "Pemotongan Berhasil",
        ApproveRemark: "Alasan Diterima",
        Detailsofexemption: "Detail Pemotongan",
        IsRepay: "Apakah ada pembayaran",
        Invalid: "Sudah kadaluarsa",
        completeTicket: 'Sudah selesai'
    },
    OrderStatus:	 {
        PartiallyCompleted	: 'Selesai sebagian',
        beyondCompareSubmitFailed	: 'Melebihi jumlah yang dapat dikurangkan, gagal	',
        manuoverdueDays	: 'Telah di eskalasi, hasil akan keluar dalam 10 menit',
        manuoverdueDaysFailed	: 'Upgrade gagal, silakan coba lagi'
    }
   // "First login time today": "今天第一次登录时间",	Waktu login pertama kali hari ini
// "Last update time": "上次更新时间",	Waktu pembaharuan terakhir 
// 'Assign Num': "分配数",	Jumlah pembagian tiket
// 'Group KPI repay amount': "小组目标回款金额",	Target group KPI
// 'KPI repay amount': "目标回款金额",	Target KPI
// "login time": "登录时间",	Waktu login
// "Half a month": "半月",	Setengah bulan
// "That day": "当日",	Hari ini
// "Target amount of returns": "目标回款金额",	Target pengembalian dana
// "Tiempo de PTP is incorrect, please fill in again": "承诺还款时间不正确，请重新填写",	Waktu PTP salah, silakan isi lagi     		
}
